import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { environment } from '../../../../environments/environment';
import { GeneralService } from 'src/app/services/service.index';
import { UtilHelper } from '../../../_helpers/util';

declare const toastr: any;
@Component({
  selector: 'app-descripcion-reporte',
  templateUrl: './descripcion-reporte.component.html',
  styleUrls: []
})
export class DescripcionReporteComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourceLstObs: any[];

  model: any = {
      id: 0,
      reporte: '',
      seccion: '',      
      activo: false,
      posicion: 0,
      parrafo: ''

  };
  dataResourceReporte: any = [{ reporte: 'informeTraspasoDgpFISICO' }, { reporte: 'informeTraspasoDgp' }, { reporte: 'informeTraspasoFin' }, { reporte: 'informeTraspasoJur' }, { reporte: 'fusManual' }];
  dataResourceSeccion: any =  [{ seccion: 'seccion A' }, { seccion: 'seccion B' }, { seccion: 'Conclusiones y Recomendaciones' }, { seccion: 'Marco Normativo' }, { seccion: 'Consideraciones Técnicas' }, { seccion: 'Análisis Jurídico' }, { seccion: 'Aclaración DGP' }];
  
  techoId: number = 0;
  techoIdE: number = 0;
  estado: string = '0';
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleEstado: boolean = false;
  baseUrl = environment.apiEndpoint;
  hasError: any;
  vigencia: any[];
  state_toogle: boolean = false;
  constructor(private _gs: GeneralService) {    
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];

  }

  ngOnInit() {
    this.getDescripciones();
  }

  clearErrors() {
    this.hasError = { reporte: false, seccion: false, activo: false, modulo_id: false, posicion: false, parrafo: false };
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },);
  }

  getDescripciones() {
    this._gs.getODescripcionLstGeneral().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.dataResourceLstObs = result.data;
        }
        else { this.dataResourceLstObs = []; }
      },
      (error) => { console.log('Error', error); });
  }

  showModalAdd() {
    this.state_toogle = false;
    this.clearErrors();
    this.popupVisibleAdd = true;
    this.cleanModel();
  }

  cleanModel(){
    this.model = {
      id: 0,
      reporte: '',
      seccion: '',      
      activo: false,
      posicion: 0,
      parrafo: ''
  
    };
  }

  saveDescripcion() {    
    if (this.model.id == 0) {
      this.model.activo = true;
      this._gs.postDescripcion(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getDescripciones();
            toastr.success('Observación registrada correctamente.');
            this.popupVisibleAdd = false;
          }
          else if (result.status == 201) {
            toastr.warning(result.data);
          }
        },
        error => { console.log('Error', error); });
    }
    else {            
      this._gs.putDescripcion(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getDescripciones();
            toastr.success('Observación registrada correctamente.');
            this.popupVisibleAdd = false;
          }
          else if (result.status == 201) {
            toastr.warning(result.data);
          }
        },
        error => { console.log('Error', error); });
    }
  }

  showModalEdit(data: any) {    
    this.state_toogle = true;
    this.clearErrors();    
    this.model.id = data.id;
    this.model.seccion = data.seccion;
    this.model.activo = data.activo;
    this.model.reporte = data.reporte;
    this.model.parrafo = data.parrafo;
    this.model.posicion = data.posicion;
    this.popupVisibleAdd = true;
  }

  showModalDelete(id: number) {
    this.model.id = id;
    this.popupVisibleDel = true;
  }

  deleteDescripcion() {
    {
      this._gs.deleteDescripcion(this.model.id).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getDescripciones();
            this.popupVisibleDel = false;
            toastr.success('Registro eliminado correctamente.');
          } else if (result.status == 201) {
            this.getDescripciones();
            this.popupVisibleDel = false;
            toastr.warning(result.data);
          }
          else {
            toastr.warning("otro");
          }
        },
        error => { console.log('Error', error); });
    }
  }

}
